// @ts-nocheck
import { computed, ref } from 'vue';
import FileWrapperMultiViewService from '../services/file-wrapper-multi-view-service';
import _ from 'lodash';
import { getI18nInstance } from '@/locales/i18nInstance';

const i18n = getI18nInstance();

const legalDisplayLengthLimit = 4;
const roundCopywriting = {
    en: {
        1: '1st',
        2: '2nd',
        3: '3rd',
    },
};

const service = ref<FileWrapperMultiViewService>();

const multiViewNodata = computed(() => {
    return service.value?.nodata;
});

// tabs数据
const multiViewTabList = computed(() => {
    return service.value.multiViewRoundList.map((item) => {
        const _round = i18n.t('fileWrapperMultiView.round', {
            // en数字后要拼接th
            round: _.get(roundCopywriting, `${i18n.locale}.${item.round}`, i18n.locale === 'en' ? `${item.round}th` : item.round),
        });
        const rejectionCopywriting = item.doc_code === 'CTNF' ? i18n.t('fileWrapperMultiView.nonFinalRejection') : i18n.t('fileWrapperMultiView.finalRejection');

        const rejection = _.get(item, 'rejection', {});
        return {
            round: item.round,
            name: `${_round} ${rejectionCopywriting}`,
            date: _.get(rejection, 'mrdt', ''),
        };
    });
});

// pn、title等的信息
const patentHeaderInfo = computed(() => {
    const legalStatus = _.clone(_.get(service.value, 'patent.LEGAL_STATUS')) || [];
    if (legalStatus.length > legalDisplayLengthLimit) legalStatus.splice(0, legalDisplayLengthLimit);
    return {
        pn: _.get(service.value, 'patent.PN'),
        title: _.get(service.value, 'patent.Origin_TITLE'),
        legalObject: {
            HAS_LICENSE: _.get(service.value, 'patent.HAS_LICENSE'),
            HAS_LITIGATION: _.get(service.value, 'patent.HAS_LITIGATION'),
            HAS_STANDARD: _.get(service.value, 'patent.HAS_STANDARD'),
        },
        legalStatus,
    };
});

// 当前选中的轮次
const currentRound = ref(1);

// 当前轮次的数据
const currentRoundDetail = computed(() => {
    return _.find(service.value.multiViewRoundList, { round: currentRound.value }, {});
});

export const createService = async (patentId: string) => {
    service.value = new FileWrapperMultiViewService(patentId);
    return service.value.init();
};

export const destroyService = () => {
    service.value = {};
    currentRound.value = 1;
};

export default function useFileWrapperMultiView() {
    return {
        service,
        patentHeaderInfo,
        currentRound,
        currentRoundDetail,
        multiViewNodata,
        multiViewTabList,
    };
}
